var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7272 6.83765C13.09 7.20386 13.09 7.79858 12.7272 8.1648L8.08438 12.8523C7.72165 13.2185 7.13259 13.2185 6.76987 12.8523C6.40714 12.4861 6.40714 11.8914 6.76987 11.5251L9.83125 8.43726H0.928571C0.414955 8.43726 0 8.01831 0 7.49976C0 6.9812 0.414955 6.56226 0.928571 6.56226H9.82835L6.77277 3.47437C6.41004 3.10816 6.41004 2.51343 6.77277 2.14722C7.13549 1.78101 7.72455 1.78101 8.08728 2.14722L12.7301 6.83472L12.7272 6.83765Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.4cb09977c08fd87791fcdf4c08c3a909.svg";
export { ForwardRef as ReactComponent };